<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>

          <CCardBody>
            <BTabs  >
              <CTab  title="Roles">
                <BackDoor/>
              </CTab>

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import BTabs from "../../tabs/BTabs";
import BackDoor from "./BackDoor";
export default {
  name: 'Login',
  components: {
    BTabs,
    BackDoor
  },
  data() {
    return {

    }
  }, mounted() {

  }, watch: {

  },
  methods: {

  }
}

</script>
